import React, { useRef } from "react";
import AppModalWrapper from "../components/Items/Modal/AppModalWrapper";
import RxLabel from "../pages/RxLabel";
import { useReactToPrint } from "react-to-print";

import { Button, Col, Row } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const ViewRxLabelModal: React.FC<IPrintRxLabelModal> = ({
  show,
  handleClose,
  order,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
  });

  return (
    <>
      <AppModalWrapper
        title="View Rx"
        headerStyle={{
          backgroundColor: "#f5f5f5",
          color: "#101828",
          fontSize: "16px",
          fontWeight: "700",
          height: "50px",
        }}
        width={"60%"}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        <Row>
          <Col span={24} style={{ marginBottom: "16px" }}>
            <Button
              icon={<PrinterOutlined />}
              onClick={reactToPrintFn}
              type="primary"
            >
              Print
            </Button>
          </Col>
        </Row>
        <div
          className="print-ref-container-twinge"
          style={{ width: "144px", height: "94px" }}
          ref={contentRef}
        >
          <RxLabel order={order} />
        </div>
      </AppModalWrapper>
    </>
  );
};
export default ViewRxLabelModal;
